// Spread in: Highcharts types only declare allowOverlap on plot band labels.
export const PLOT_LINE_LABEL_ALLOW_OVERLAP = { allowOverlap: true };
